import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import ObjectiveValuePillarServices from "./ObjectiveValuePillar.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetObjectiveValuePillar = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: true,
    });
    dispatch({
      type: actions.GET_OBJECTIVE_VALUE_PILLAR,
      payload: {
        objectiveValuePillars: [],
        objectiveValuePillarsLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_VALUE_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: false,
    });
  }
};

export const getObjectiveValuePillar = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: true,
    });
    const resp = await ObjectiveValuePillarServices.getObjectiveValuePillar(filters);
    dispatch({
      type: actions.GET_OBJECTIVE_VALUE_PILLAR,
      payload: {
        objectiveValuePillars: resp.data.data || [],
        objectiveValuePillarsLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_VALUE_PILLAR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.OBJECTIVE_VALUE_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: false,
    });
  }
};

export const getObjectiveValuePillarById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR_BY_ID,
      payload: true,
    });
    const resp = await ObjectiveValuePillarServices.getObjectiveValuePillarById(id);
    dispatch({
      type: actions.GET_OBJECTIVE_VALUE_PILLAR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.OBJECTIVE_VALUE_PILLAR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.OBJECTIVE_VALUE_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR_BY_ID,
      payload: false,
    });
  }
};

export const saveObjectiveValuePillar = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: true,
    });
    const resp = await ObjectiveValuePillarServices.saveObjectiveValuePillar(data);
    const { objectiveValuePillars, objectiveValuePillarsLength } = getState().objectiveValuePillar;
    const _objectiveValuePillars = [...objectiveValuePillars, resp.data];
    dispatch({
      type: actions.GET_OBJECTIVE_VALUE_PILLAR,
      payload: {
        objectiveValuePillars: _objectiveValuePillars,
        objectiveValuePillarsLength: objectiveValuePillarsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: false,
    });
  }
};

export const editObjectiveValuePillar = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: true,
    });
    const resp = await ObjectiveValuePillarServices.editObjectiveValuePillar(id, data);
    const { objectiveValuePillars, objectiveValuePillarsLength } = getState().objectiveValuePillar;
    objectiveValuePillars[index] = resp.data;
    dispatch({
      type: actions.GET_OBJECTIVE_VALUE_PILLAR,
      payload: {
        objectiveValuePillars: objectiveValuePillars,
        objectiveValuePillarsLength: objectiveValuePillarsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: false,
    });
  }
};

export const deleteObjectiveValuePillar = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: true,
    });
    await ObjectiveValuePillarServices.deleteObjectiveValuePillar(id);
    const { objectiveValuePillars, objectiveValuePillarsLength } = getState().objectiveValuePillar;
    objectiveValuePillars.splice(index, 1);
    dispatch({
      type: actions.GET_OBJECTIVE_VALUE_PILLAR,
      payload: {
        objectiveValuePillars: objectiveValuePillars,
        objectiveValuePillarsLength: objectiveValuePillarsLength - 1,
      },
    });
    dispatch({
      type: actions.OBJECTIVE_VALUE_PILLAR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_OBJECTIVE_VALUE_PILLAR,
      payload: false,
    });
  }
};
